import computeClassName from "../../../../../../utils/computeClassName";

export default function CCLoaderCircleMedium({className}) {
  const computedClassName = computeClassName(className, '');
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={computedClassName}>
      <path fillRule="evenodd" clipRule="evenodd" d="M15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10ZM10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z" fill="#CEE6FC"/>
      <mask id="maskCCLoaderCircleMedium" mask-type="alpha" maskUnits="userSpaceOnUse" x="2" y="2" width="16" height="16">
        <path fillRule="evenodd" clipRule="evenodd" d="M15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10ZM10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z" fill="white"/>
      </mask>
      <g mask="url(#maskCCLoaderCircleMedium)">
        <path fillRule="evenodd" clipRule="evenodd" d="M9.99878 5C9.99922 5 9.99967 5 10.0001 5C12.7615 5 15.0001 7.23858 15.0001 10H17.9988C17.9988 5.58171 14.4171 2 9.99878 2V5Z" fill="#0076D5"/>
      </g>
    </svg>

  );
}
